/**
 * ThreatCat renamed `Entity.technical_information` to `Entity.label` (migration
 * 0c9e9e64e2da, 2026-07-21). SPICE follows that naming; this helper keeps
 * pre-rename project exports readable.
 */
export type EntityLabelSource = {
  label?: string;
  /** Pre-rename field name, still present in older ThreatCat exports. */
  technical_information?: string;
};

export function entityLabel(entity: EntityLabelSource): string {
  return entity.label || entity.technical_information || '';
}
